import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackDepletedStateViewed.meta';

export type UseTrackDepletedStateViewedParams = {
  surface: 'upload_modal' | 'canvas' | 'banner';
  days_since_cycle_start: number;
};

export const useTrackDepletedStateViewed = () => {
  const { track } = useAnalyticsUtilities();

  const trackDepletedStateViewed = useCallback(
    (params: UseTrackDepletedStateViewedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackDepletedStateViewed };
};
